/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { usePlayerComponents } from "../../shared/context/PlayerComponentsContext";
import { usePlayerLoadingState } from "../Controller";

export const LoadingSpinner = () => {
  const { isLoading } = usePlayerLoadingState();
  const { LoaderSpinner } = usePlayerComponents();

  return <>{isLoading && <LoaderSpinner />}</>;
};
